function getObjectTextByPropVal(val, array, prop, textProp) {
  const arrItem = array.find((item) => item[prop] === val);
  if (arrItem) {
    return arrItem[textProp];
  } else {
    return "undefined";
  }
}

export { getObjectTextByPropVal };
